export default "__VITE_PUBLIC_ASSET__10827179__"